export const mutations = {
  SET_EXPAND_LIST: 'SET_EXPAND_LIST',
  SET_SEARCH_BY: 'SET_SEARCH_BY',
  SET_FETCHED_ALL: 'SET_FETCHED_ALL',
  SET_FETCHED_ALL_QUERY: 'SET_FETCHED_ALL_QUERY',
  SET_ASSIGNED_PRODUCT: 'SET_ASSIGNED_PRODUCT',
  UPDATE_ASSIGNED_PRODUCT: 'UPDATE_ASSIGNED_PRODUCT',
  SET_SELECT_ALL: 'SET_SELECT_ALL',
  RESET_SEARCH_RESULT: 'RESET_SEARCH_RESULT',
  RESET_PRODUCT_DATA: 'RESET_PRODUCT_DATA',
  RESET_SELECT_PRODUCT: 'RESET_SELECT_PRODUCT',
  RESET_SELECT_BY_FILTER: 'RESET_SELECT_BY_FILTER',
  REFRESH_PRODUCT_DATA: 'REFRESH_PRODUCT_DATA',
};

export const actions = {
  GET_PRODUCTS: 'getProducts',
  GET_LIST_BY_FILTER: 'getListByFilter',
  GET_PRODUCTS_BY_FILTER: 'getProductsByFilter',
  UPDATE_PAGE_ASSIGNMENT: 'updatePageAssignment',
};

export const getters = {
  GET_FETCH_ALL: 'GET_FETCH_ALL',
  GET_FETCH_ALL_QUERY: 'GET_FETCH_ALL_QUERY',
  GET_FETCH_ALL_PAGES: 'GET_FETCH_ALL_PAGES',
  GET_FETCH_ALL_PAGES_QUERY: 'GET_FETCH_ALL_PAGES_QUERY',
  GET_FETCH_ALL_COLLECTIONS: 'GET_FETCH_ALL_COLLECTIONS',
  GET_FETCH_ALL_COLLECTIONS_QUERY: 'GET_FETCH_ALL_COLLECTIONS_QUERY',
};

export class ProductStore {
  public all: ProductListStore;
  public collections: ProductListStore;
  public pages: ProductListStore;
  public assignment: AssignmentStore;

  constructor() {
    this.all = new ProductListStore();
    this.collections = new ProductListStore();
    this.pages = new ProductListStore();
    this.assignment = new AssignmentStore();
  }
}
export class ProductListStore {
  public list: any[];
  public products?: any[];
  public queryList: any[];
  public fetched: boolean;
  public queryFetched: boolean;
  public expandedList?: any[];
  public endCursor: string;
  public endCursorQuery: string;

  constructor() {
    this.list = [];
    this.queryList = [];
    this.products = [];
    this.fetched = false;
    this.queryFetched = false;
    this.expandedList = [];
    this.endCursor = '';
    this.endCursorQuery = '';
  }
}
export class AssignmentStore {
  public assigned: Set<any>;
  public selected: Set<any>;
  public unselected: Set<any>;

  constructor() {
    this.assigned = new Set();
    this.selected = new Set();
    this.unselected = new Set();
  }
}
